/* <material-guide> — scroll-spy navigation for the material guide.
   Highlights the nav link of the material currently in view and keeps the
   active link visible in the horizontal nav on mobile. Vanilla ES6, no deps. */
class MaterialGuide extends HTMLElement {
  connectedCallback() {
    this.links = Array.from(this.querySelectorAll('[data-mg-link]'));
    this.sections = Array.from(this.querySelectorAll('[data-mg-section]'));
    if (!this.links.length || !this.sections.length) return;

    this.linkFor = new Map(this.links.map((l) => [l.dataset.mgLink, l]));
    this.onClick = this.onClick.bind(this);
    this.addEventListener('click', this.onClick);

    // Scroll-spy: the section whose top is nearest below the sticky offset wins.
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.setActive(entry.target.dataset.mgSection);
        });
      },
      { rootMargin: '-25% 0px -65% 0px', threshold: 0 }
    );
    this.sections.forEach((s) => this.observer.observe(s));
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    if (this.observer) this.observer.disconnect();
  }

  onClick(event) {
    const link = event.target.closest('[data-mg-link]');
    if (!link) return;
    const target = document.getElementById(link.dataset.mgLink);
    if (!target) return;
    event.preventDefault();
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    target.scrollIntoView({ behavior: motion, block: 'start' });
    this.setActive(link.dataset.mgLink);
    if (history.replaceState) history.replaceState(null, '', '#' + link.dataset.mgLink);
  }

  setActive(id) {
    const link = this.linkFor.get(id);
    if (!link || link === this.current) return;
    this.links.forEach((l) => l.classList.remove('is-active'));
    link.classList.add('is-active');
    this.current = link;
    // Keep the active pill in view within a horizontally scrolling nav (mobile).
    const nav = link.closest('.mg__nav');
    if (nav && nav.scrollWidth > nav.clientWidth) {
      link.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
  }
}

customElements.define('material-guide', MaterialGuide);
